@if (colorLoader) {
  <div class="mh">
    <p-progressSpinner
      strokeWidth="5"
      fill="#EEEEEE"
      animationDuration=".5s"></p-progressSpinner>
  </div>
}

@if (!colorLoader) {
  <div>
    <div class="topedit" [ngClass]="{ 'background-purple': isMRPPProgram }">
      <span>{{
        isMRPPProgram ? 'Meeting Room Partner Program' : 'Engagement'
      }}</span>
    </div>
  </div>

  <app-event-details
    #eventDetailsHeader
    [eventRegistrationId]="eventRegistrationId"
    [programTypeGUID]="programTypeGUID"
    [eventCustomers]="eventCustomers"></app-event-details>

  <div
    class="scrollcontent boxtb"
    [ngClass]="isFullScreen ? 'overflow-fullscreen' : 'overflow-setting'">
    <p-tabs scrollable class="tabView" value="0">
      <p-tablist>
        <p-tab value="0">Partner</p-tab>
        @if (isMRPPProgram) {
          <p-tab value="1">Payment Profile</p-tab>
        }
        @if (isOneToMany) {
          <p-tab value="2">{{ getCustomerDetails() }}</p-tab>
        }
        @if (!isOneToMany) {
          <p-tab value="3">Customer Details</p-tab>
        }
        <p-tab value="4">{{ detailsTabHeader }}</p-tab>
        <p-tab value="5">{{ tabHeader }}</p-tab>
        <p-tab value="6">Engagement Payment Milestone 2</p-tab>
        <p-tab value="7">POE Submission</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <app-partner-details
            (refreshNotes)="refreshNotes()"
            [eventRegistrationId]="eventRegistrationId"
            [isMRPPProgram]="isMRPPProgram"></app-partner-details>
        </p-tabpanel>
        <p-tabpanel value="1">
          <app-payment-profile-tab
            [partnerPaymentDetails]="
              profilePaymentDetails
            "></app-payment-profile-tab>
        </p-tabpanel>
        <p-tabpanel value="2">
          <div class="customer-scroll m-0">
            <h3 class="customer-header border-bottom">Customer Name</h3>
            <ul class="customer-name-list">
              @for (customer of eventCustomers; track customer) {
                <li>
                  {{ customer.customerName }}
                </li>
              }
            </ul>
          </div>
        </p-tabpanel>
        <p-tabpanel value="3">
          <app-one-to-one-customer-details
            [eventId]="eventRegistrationId"
            (refreshEventDetails)="
              refreshEventDetails()
            "></app-one-to-one-customer-details>
        </p-tabpanel>
        <p-tabpanel value="4">
          <app-event-details-tab
            #eventDetailsTab
            (refreshEventDetails)="refreshEventDetails()"
            [eventRegistrationId]="eventRegistrationId"
            [programTypeGUID]="programTypeGUID"></app-event-details-tab>
        </p-tabpanel>
        <p-tabpanel value="5">
          <app-event-payment-information
            [eventId]="eventRegistrationId"
            [isMRPPProgram]="isMRPPProgram"
            [programTypeGUID]="programTypeGUID"></app-event-payment-information>
        </p-tabpanel>
        <p-tabpanel value="6">
          <app-event-milestone2-payment-information
            [eventId]="eventRegistrationId"
            [programTypeGUID]="
              programTypeGUID
            "></app-event-milestone2-payment-information>
        </p-tabpanel>
        <p-tabpanel value="7">
          <app-event-poe-submission
            (refreshEventDetails)="refreshEventHeaderAndDetails()"
            [programTypeGUID]="programTypeGUID"
            [eventRegistrationId]="
              eventRegistrationId
            "></app-event-poe-submission>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
}
